import { FeatureFlags } from '../types';

export const FEATURE_FLAGS_QUERY_INPUT = {
  input: {
    names: Object.values(FeatureFlags),
  },
};
